import { Heading, Modal, Paragraph } from 'canoe';
import React from 'react';

interface Props {
  onClose: VoidFunction;
  onSubmit: VoidFunction;
}

export const RemoveSnapshotModal = ({ onClose, onSubmit }: Props) => {
  return (
    <Modal onClose={onClose} closeOnClickOutside>
      <Modal.Body>
        <Heading size="S" mt="normal" mb="normal">
          Remove Snapshot?
        </Heading>
        <Paragraph size="short" color="OnyxGrayL10">
          Deleting a Snapshot erases Placement URL data and Overlay display frequency permanently.
          Please note that this action cannot be undone.
        </Paragraph>
      </Modal.Body>
      <Modal.Footer
        justify="space-between"
        secondaryAction={{
          children: 'Close',
          onClick: onClose,
        }}
        primaryAction={{
          children: 'Remove Snapshot',
          variant: 'danger',
          onClick: onSubmit,
        }}
      />
    </Modal>
  );
};
